// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables for S-CUBUS Theme System */

:root {
  /* Primary Brand Colors */
  --color-primary: #400C4D;
  --color-primary-light: #4a1548;
  --color-primary-dark: #2a0829;
  --color-primary-rgb: 55, 11, 59;
  --color-primary-alpha: rgba(64, 12, 77, 0.1);
  
  /* Secondary Colors */
  --color-secondary: #f39c12;
  --color-secondary-light: #f5b041;
  --color-secondary-dark: #d68910;
  --color-secondary-rgb: 243, 156, 18;
  
  /* Accent Colors */
  --color-accent: #e74c3c;
  --color-accent-light: #ec7063;
  --color-accent-dark: #c0392b;
  --color-accent-rgb: 231, 76, 60;
  
  /* Success/Warning/Error Colors */
  --color-success: #27ae60;
  --color-success-light: #58d68d;
  --color-success-dark: #1e8449;
  --color-success-rgb: 39, 174, 96;
  
  --color-warning: #f39c12;
  --color-warning-light: #f5b041;
  --color-warning-dark: #d68910;
  --color-warning-rgb: 243, 156, 18;
  
  --color-error: #e74c3c;
  --color-error-light: #ec7063;
  --color-error-dark: #c0392b;
  --color-error-rgb: 231, 76, 60;
  
  --color-info: #3498db;
  --color-info-light: #5dade2;
  --color-info-dark: #2980b9;
  --color-info-rgb: 52, 152, 219;
  
  /* Light Theme Colors */
  --color-background: #ffffff;
  --color-background-rgb: 255, 255, 255;
  --color-surface: #f8f9fa;
  --color-surface-rgb: 248, 249, 250;
  --color-surface-elevated: #ffffff;
  --color-surface-elevated-rgb: 255, 255, 255;
  --color-surface-dark: #2c3e50;
  --color-surface-dark-rgb: 44, 62, 80;
  
  --color-text: #2c3e50;
  --color-text-rgb: 44, 62, 80;
  --color-text-secondary: #7f8c8d;
  --color-text-secondary-rgb: 127, 140, 141;
  --color-text-muted: #95a5a6;
  --color-text-muted-rgb: 149, 165, 166;
  --color-text-light: #ffffff;
  --color-text-light-rgb: 255, 255, 255;
  
  --color-border: #e9ecef;
  --color-border-rgb: 233, 236, 239;
  --color-border-light: #f1f3f4;
  --color-border-light-rgb: 241, 243, 244;
  --color-border-dark: #404040;
  --color-border-dark-rgb: 64, 64, 64;
  
  --color-shadow: rgba(0, 0, 0, 0.1);
  --color-shadow-light: rgba(0, 0, 0, 0.05);
  --color-shadow-dark: rgba(0, 0, 0, 0.2);
  
  /* Typography Scale */
  --font-family-primary: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-family-heading: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-family-mono: 'Fira Code', 'Monaco', 'Cascadia Code', monospace;
  
  /* Font Sizes */
  --font-size-xs: 0.75rem;    /* 12px */
  --font-size-sm: 0.875rem;   /* 14px */
  --font-size-base: 1rem;     /* 16px */
  --font-size-lg: 1.125rem;   /* 18px */
  --font-size-xl: 1.25rem;    /* 20px */
  --font-size-2xl: 1.5rem;    /* 24px */
  --font-size-3xl: 1.875rem;  /* 30px */
  --font-size-4xl: 2.25rem;   /* 36px */
  --font-size-5xl: 3rem;      /* 48px */
  --font-size-6xl: 3.75rem;   /* 60px */
  --font-size-7xl: 4.5rem;    /* 72px */
  --font-size-8xl: 6rem;      /* 96px */
  --font-size-9xl: 8rem;      /* 128px */
  
  /* Font Weights */
  --font-weight-thin: 100;
  --font-weight-extralight: 200;
  --font-weight-light: 300;
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;
  --font-weight-black: 900;
  
  /* Line Heights */
  --line-height-none: 1;
  --line-height-tight: 1.25;
  --line-height-snug: 1.375;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.625;
  --line-height-loose: 2;
  
  /* Letter Spacing */
  --letter-spacing-tighter: -0.05em;
  --letter-spacing-tight: -0.025em;
  --letter-spacing-normal: 0em;
  --letter-spacing-wide: 0.025em;
  --letter-spacing-wider: 0.05em;
  --letter-spacing-widest: 0.1em;
  
  /* Spacing Scale */
  --spacing-0: 0;
  --spacing-px: 1px;
  --spacing-0-5: 0.125rem;  /* 2px */
  --spacing-1: 0.25rem;     /* 4px */
  --spacing-1-5: 0.375rem;  /* 6px */
  --spacing-2: 0.5rem;      /* 8px */
  --spacing-2-5: 0.625rem;  /* 10px */
  --spacing-3: 0.75rem;     /* 12px */
  --spacing-3-5: 0.875rem;  /* 14px */
  --spacing-4: 1rem;        /* 16px */
  --spacing-5: 1.25rem;     /* 20px */
  --spacing-6: 1.5rem;      /* 24px */
  --spacing-7: 1.75rem;     /* 28px */
  --spacing-8: 2rem;        /* 32px */
  --spacing-9: 2.25rem;     /* 36px */
  --spacing-10: 2.5rem;     /* 40px */
  --spacing-11: 2.75rem;    /* 44px */
  --spacing-12: 3rem;       /* 48px */
  --spacing-14: 3.5rem;     /* 56px */
  --spacing-16: 4rem;       /* 64px */
  --spacing-20: 5rem;       /* 80px */
  --spacing-24: 6rem;       /* 96px */
  --spacing-28: 7rem;       /* 112px */
  --spacing-32: 8rem;       /* 128px */
  --spacing-36: 9rem;       /* 144px */
  --spacing-40: 10rem;      /* 160px */
  --spacing-44: 11rem;      /* 176px */
  --spacing-48: 12rem;      /* 192px */
  --spacing-52: 13rem;      /* 208px */
  --spacing-56: 14rem;      /* 224px */
  --spacing-60: 15rem;      /* 240px */
  --spacing-64: 16rem;      /* 256px */
  --spacing-72: 18rem;      /* 288px */
  --spacing-80: 20rem;      /* 320px */
  --spacing-96: 24rem;      /* 384px */
  
  /* Border Radius */
  --radius-none: 0;
  --radius-sm: 0.125rem;   /* 2px */
  --radius-base: 0.25rem;  /* 4px */
  --radius-md: 0.375rem;   /* 6px */
  --radius-lg: 0.5rem;     /* 8px */
  --radius-xl: 0.75rem;    /* 12px */
  --radius-2xl: 1rem;      /* 16px */
  --radius-3xl: 1.5rem;    /* 24px */
  --radius-full: 9999px;
  
  /* Border Widths */
  --border-width-0: 0px;
  --border-width-1: 1px;
  --border-width-2: 2px;
  --border-width-4: 4px;
  --border-width-8: 8px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-base: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --shadow-inner: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  --shadow-none: 0 0 #0000;
  
  /* Transitions */
  --transition-none: none;
  --transition-all: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slower: 500ms cubic-bezier(0.4, 0, 0.2, 1);
  
  /* Easing Functions */
  --ease-linear: linear;
  --ease-in: cubic-bezier(0.4, 0, 1, 1);
  --ease-out: cubic-bezier(0, 0, 0.2, 1);
  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  
  /* Z-Index Scale */
  --z-auto: auto;
  --z-0: 0;
  --z-10: 10;
  --z-20: 20;
  --z-30: 30;
  --z-40: 40;
  --z-50: 50;
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
  --z-toast: 1080;
  --z-max: 2147483647;
  
  /* Responsive Breakpoints */
  --breakpoint-xs: 475px;
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
  --breakpoint-2xl: 1536px;
  
  /* Container Max Widths */
  --container-xs: 475px;
  --container-sm: 640px;
  --container-md: 768px;
  --container-lg: 1024px;
  --container-xl: 1280px;
  --container-2xl: 1536px;
  
  /* Grid System */
  --grid-columns: 12;
  --grid-gap: var(--spacing-6);
  --grid-gap-sm: var(--spacing-4);
  --grid-gap-lg: var(--spacing-8);
  
  /* Component Specific Variables */
  --navbar-height: 4rem;
  --sidebar-width: 16rem;
  --footer-height: auto;
  
  /* Animation Durations */
  --duration-75: 75ms;
  --duration-100: 100ms;
  --duration-150: 150ms;
  --duration-200: 200ms;
  --duration-300: 300ms;
  --duration-500: 500ms;
  --duration-700: 700ms;
  --duration-1000: 1000ms;
}

/* High Contrast Theme (Accessibility) */
[data-theme="high-contrast"] {
  --color-background: #000000;
  --color-background-rgb: 0, 0, 0;
  --color-surface: #000000;
  --color-surface-rgb: 0, 0, 0;
  --color-surface-elevated: #1a1a1a;
  --color-surface-elevated-rgb: 26, 26, 26;
  
  --color-text: #ffffff;
  --color-text-rgb: 255, 255, 255;
  --color-text-secondary: #ffffff;
  --color-text-secondary-rgb: 255, 255, 255;
  --color-text-muted: #cccccc;
  --color-text-muted-rgb: 204, 204, 204;
  
  --color-border: #ffffff;
  --color-border-rgb: 255, 255, 255;
  --color-border-light: #cccccc;
  --color-border-light-rgb: 204, 204, 204;
  
  --color-primary: #ffffff;
  --color-primary-rgb: 255, 255, 255;
  --color-secondary: #ffff00;
  --color-secondary-rgb: 255, 255, 0;
  --color-accent: #ff0000;
  --color-accent-rgb: 255, 0, 0;
  
  --color-success: #00ff00;
  --color-success-rgb: 0, 255, 0;
  --color-warning: #ffff00;
  --color-warning-rgb: 255, 255, 0;
  --color-error: #ff0000;
  --color-error-rgb: 255, 0, 0;
  --color-info: #00ffff;
  --color-info-rgb: 0, 255, 255;
}

/* Reduced Motion Preferences */
@media (prefers-reduced-motion: reduce) {
  :root {
    --transition-none: none;
    --transition-all: none;
    --transition-fast: none;
    --transition-base: none;
    --transition-slow: none;
    --transition-slower: none;
    
    --duration-75: 0ms;
    --duration-100: 0ms;
    --duration-150: 0ms;
    --duration-200: 0ms;
    --duration-300: 0ms;
    --duration-500: 0ms;
    --duration-700: 0ms;
    --duration-1000: 0ms;
  }
}

/* High Contrast Preference */
@media (prefers-contrast: high) {
  :root:not([data-theme]) {
    --color-border: #000000;
    --color-text: #000000;
    --color-background: #ffffff;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/variables.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,4CAA4C;;EAE5C,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,mCAAmC;;EAEnC,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;;EAE/B,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;;EAEhC,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;;EAEjC,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;;EAE9B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;;EAE9B,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;EACrC,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,2CAA2C;EAC3C,6BAA6B;EAC7B,oCAAoC;;EAEpC,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,qCAAqC;;EAErC,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,4BAA4B;EAC5B,mCAAmC;;EAEnC,kCAAkC;EAClC,yCAAyC;EACzC,uCAAuC;;EAEvC,qBAAqB;EACrB,qGAAqG;EACrG,qGAAqG;EACrG,qEAAqE;;EAErE,eAAe;EACf,uBAAuB,KAAK,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,sBAAsB,MAAM,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,yBAAyB,GAAG,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,qBAAqB,OAAO,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,qBAAqB,OAAO,SAAS;EACrC,qBAAqB,OAAO,UAAU;;EAEtC,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;;EAExB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;;EAEtB,mBAAmB;EACnB,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB,GAAG,QAAQ;EAClC,oBAAoB,MAAM,QAAQ;EAClC,uBAAuB,GAAG,QAAQ;EAClC,mBAAmB,OAAO,QAAQ;EAClC,uBAAuB,GAAG,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,uBAAuB,GAAG,SAAS;EACnC,iBAAiB,SAAS,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,mBAAmB,OAAO,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,iBAAiB,SAAS,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,qBAAqB,KAAK,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,kBAAkB,QAAQ,UAAU;EACpC,kBAAkB,QAAQ,UAAU;EACpC,kBAAkB,QAAQ,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;;EAEpC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,IAAI,QAAQ;EACjC,sBAAsB,GAAG,QAAQ;EACjC,qBAAqB,IAAI,QAAQ;EACjC,mBAAmB,MAAM,QAAQ;EACjC,oBAAoB,KAAK,SAAS;EAClC,kBAAkB,OAAO,SAAS;EAClC,oBAAoB,KAAK,SAAS;EAClC,qBAAqB;;EAErB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,YAAY;EACZ,4CAA4C;EAC5C,8EAA8E;EAC9E,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD;EACnD,qDAAqD;EACrD,wBAAwB;;EAExB,gBAAgB;EAChB,uBAAuB;EACvB,wDAAwD;EACxD,qDAAqD;EACrD,qDAAqD;EACrD,qDAAqD;EACrD,uDAAuD;;EAEvD,qBAAqB;EACrB,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,2CAA2C;;EAE3C,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;;EAEnB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;;EAEvB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;;EAE/B,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;;EAErB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;EACjC,wCAAwC;;EAExC,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;EAC3B,qCAAqC;;EAErC,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;;EAEvC,wBAAwB;EACxB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;EACvB,6BAA6B;;EAE7B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;;IAEzB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;EAC7B;;AAEF","sourcesContent":["/* CSS Variables for S-CUBUS Theme System */\n\n:root {\n  /* Primary Brand Colors */\n  --color-primary: #400C4D;\n  --color-primary-light: #4a1548;\n  --color-primary-dark: #2a0829;\n  --color-primary-rgb: 55, 11, 59;\n  --color-primary-alpha: rgba(64, 12, 77, 0.1);\n  \n  /* Secondary Colors */\n  --color-secondary: #f39c12;\n  --color-secondary-light: #f5b041;\n  --color-secondary-dark: #d68910;\n  --color-secondary-rgb: 243, 156, 18;\n  \n  /* Accent Colors */\n  --color-accent: #e74c3c;\n  --color-accent-light: #ec7063;\n  --color-accent-dark: #c0392b;\n  --color-accent-rgb: 231, 76, 60;\n  \n  /* Success/Warning/Error Colors */\n  --color-success: #27ae60;\n  --color-success-light: #58d68d;\n  --color-success-dark: #1e8449;\n  --color-success-rgb: 39, 174, 96;\n  \n  --color-warning: #f39c12;\n  --color-warning-light: #f5b041;\n  --color-warning-dark: #d68910;\n  --color-warning-rgb: 243, 156, 18;\n  \n  --color-error: #e74c3c;\n  --color-error-light: #ec7063;\n  --color-error-dark: #c0392b;\n  --color-error-rgb: 231, 76, 60;\n  \n  --color-info: #3498db;\n  --color-info-light: #5dade2;\n  --color-info-dark: #2980b9;\n  --color-info-rgb: 52, 152, 219;\n  \n  /* Light Theme Colors */\n  --color-background: #ffffff;\n  --color-background-rgb: 255, 255, 255;\n  --color-surface: #f8f9fa;\n  --color-surface-rgb: 248, 249, 250;\n  --color-surface-elevated: #ffffff;\n  --color-surface-elevated-rgb: 255, 255, 255;\n  --color-surface-dark: #2c3e50;\n  --color-surface-dark-rgb: 44, 62, 80;\n  \n  --color-text: #2c3e50;\n  --color-text-rgb: 44, 62, 80;\n  --color-text-secondary: #7f8c8d;\n  --color-text-secondary-rgb: 127, 140, 141;\n  --color-text-muted: #95a5a6;\n  --color-text-muted-rgb: 149, 165, 166;\n  --color-text-light: #ffffff;\n  --color-text-light-rgb: 255, 255, 255;\n  \n  --color-border: #e9ecef;\n  --color-border-rgb: 233, 236, 239;\n  --color-border-light: #f1f3f4;\n  --color-border-light-rgb: 241, 243, 244;\n  --color-border-dark: #404040;\n  --color-border-dark-rgb: 64, 64, 64;\n  \n  --color-shadow: rgba(0, 0, 0, 0.1);\n  --color-shadow-light: rgba(0, 0, 0, 0.05);\n  --color-shadow-dark: rgba(0, 0, 0, 0.2);\n  \n  /* Typography Scale */\n  --font-family-primary: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-family-heading: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-family-mono: 'Fira Code', 'Monaco', 'Cascadia Code', monospace;\n  \n  /* Font Sizes */\n  --font-size-xs: 0.75rem;    /* 12px */\n  --font-size-sm: 0.875rem;   /* 14px */\n  --font-size-base: 1rem;     /* 16px */\n  --font-size-lg: 1.125rem;   /* 18px */\n  --font-size-xl: 1.25rem;    /* 20px */\n  --font-size-2xl: 1.5rem;    /* 24px */\n  --font-size-3xl: 1.875rem;  /* 30px */\n  --font-size-4xl: 2.25rem;   /* 36px */\n  --font-size-5xl: 3rem;      /* 48px */\n  --font-size-6xl: 3.75rem;   /* 60px */\n  --font-size-7xl: 4.5rem;    /* 72px */\n  --font-size-8xl: 6rem;      /* 96px */\n  --font-size-9xl: 8rem;      /* 128px */\n  \n  /* Font Weights */\n  --font-weight-thin: 100;\n  --font-weight-extralight: 200;\n  --font-weight-light: 300;\n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  --font-weight-extrabold: 800;\n  --font-weight-black: 900;\n  \n  /* Line Heights */\n  --line-height-none: 1;\n  --line-height-tight: 1.25;\n  --line-height-snug: 1.375;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.625;\n  --line-height-loose: 2;\n  \n  /* Letter Spacing */\n  --letter-spacing-tighter: -0.05em;\n  --letter-spacing-tight: -0.025em;\n  --letter-spacing-normal: 0em;\n  --letter-spacing-wide: 0.025em;\n  --letter-spacing-wider: 0.05em;\n  --letter-spacing-widest: 0.1em;\n  \n  /* Spacing Scale */\n  --spacing-0: 0;\n  --spacing-px: 1px;\n  --spacing-0-5: 0.125rem;  /* 2px */\n  --spacing-1: 0.25rem;     /* 4px */\n  --spacing-1-5: 0.375rem;  /* 6px */\n  --spacing-2: 0.5rem;      /* 8px */\n  --spacing-2-5: 0.625rem;  /* 10px */\n  --spacing-3: 0.75rem;     /* 12px */\n  --spacing-3-5: 0.875rem;  /* 14px */\n  --spacing-4: 1rem;        /* 16px */\n  --spacing-5: 1.25rem;     /* 20px */\n  --spacing-6: 1.5rem;      /* 24px */\n  --spacing-7: 1.75rem;     /* 28px */\n  --spacing-8: 2rem;        /* 32px */\n  --spacing-9: 2.25rem;     /* 36px */\n  --spacing-10: 2.5rem;     /* 40px */\n  --spacing-11: 2.75rem;    /* 44px */\n  --spacing-12: 3rem;       /* 48px */\n  --spacing-14: 3.5rem;     /* 56px */\n  --spacing-16: 4rem;       /* 64px */\n  --spacing-20: 5rem;       /* 80px */\n  --spacing-24: 6rem;       /* 96px */\n  --spacing-28: 7rem;       /* 112px */\n  --spacing-32: 8rem;       /* 128px */\n  --spacing-36: 9rem;       /* 144px */\n  --spacing-40: 10rem;      /* 160px */\n  --spacing-44: 11rem;      /* 176px */\n  --spacing-48: 12rem;      /* 192px */\n  --spacing-52: 13rem;      /* 208px */\n  --spacing-56: 14rem;      /* 224px */\n  --spacing-60: 15rem;      /* 240px */\n  --spacing-64: 16rem;      /* 256px */\n  --spacing-72: 18rem;      /* 288px */\n  --spacing-80: 20rem;      /* 320px */\n  --spacing-96: 24rem;      /* 384px */\n  \n  /* Border Radius */\n  --radius-none: 0;\n  --radius-sm: 0.125rem;   /* 2px */\n  --radius-base: 0.25rem;  /* 4px */\n  --radius-md: 0.375rem;   /* 6px */\n  --radius-lg: 0.5rem;     /* 8px */\n  --radius-xl: 0.75rem;    /* 12px */\n  --radius-2xl: 1rem;      /* 16px */\n  --radius-3xl: 1.5rem;    /* 24px */\n  --radius-full: 9999px;\n  \n  /* Border Widths */\n  --border-width-0: 0px;\n  --border-width-1: 1px;\n  --border-width-2: 2px;\n  --border-width-4: 4px;\n  --border-width-8: 8px;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-base: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  --shadow-inner: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  --shadow-none: 0 0 #0000;\n  \n  /* Transitions */\n  --transition-none: none;\n  --transition-all: all 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slower: 500ms cubic-bezier(0.4, 0, 0.2, 1);\n  \n  /* Easing Functions */\n  --ease-linear: linear;\n  --ease-in: cubic-bezier(0.4, 0, 1, 1);\n  --ease-out: cubic-bezier(0, 0, 0.2, 1);\n  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n  \n  /* Z-Index Scale */\n  --z-auto: auto;\n  --z-0: 0;\n  --z-10: 10;\n  --z-20: 20;\n  --z-30: 30;\n  --z-40: 40;\n  --z-50: 50;\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal-backdrop: 1040;\n  --z-modal: 1050;\n  --z-popover: 1060;\n  --z-tooltip: 1070;\n  --z-toast: 1080;\n  --z-max: 2147483647;\n  \n  /* Responsive Breakpoints */\n  --breakpoint-xs: 475px;\n  --breakpoint-sm: 640px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 1024px;\n  --breakpoint-xl: 1280px;\n  --breakpoint-2xl: 1536px;\n  \n  /* Container Max Widths */\n  --container-xs: 475px;\n  --container-sm: 640px;\n  --container-md: 768px;\n  --container-lg: 1024px;\n  --container-xl: 1280px;\n  --container-2xl: 1536px;\n  \n  /* Grid System */\n  --grid-columns: 12;\n  --grid-gap: var(--spacing-6);\n  --grid-gap-sm: var(--spacing-4);\n  --grid-gap-lg: var(--spacing-8);\n  \n  /* Component Specific Variables */\n  --navbar-height: 4rem;\n  --sidebar-width: 16rem;\n  --footer-height: auto;\n  \n  /* Animation Durations */\n  --duration-75: 75ms;\n  --duration-100: 100ms;\n  --duration-150: 150ms;\n  --duration-200: 200ms;\n  --duration-300: 300ms;\n  --duration-500: 500ms;\n  --duration-700: 700ms;\n  --duration-1000: 1000ms;\n}\n\n/* High Contrast Theme (Accessibility) */\n[data-theme=\"high-contrast\"] {\n  --color-background: #000000;\n  --color-background-rgb: 0, 0, 0;\n  --color-surface: #000000;\n  --color-surface-rgb: 0, 0, 0;\n  --color-surface-elevated: #1a1a1a;\n  --color-surface-elevated-rgb: 26, 26, 26;\n  \n  --color-text: #ffffff;\n  --color-text-rgb: 255, 255, 255;\n  --color-text-secondary: #ffffff;\n  --color-text-secondary-rgb: 255, 255, 255;\n  --color-text-muted: #cccccc;\n  --color-text-muted-rgb: 204, 204, 204;\n  \n  --color-border: #ffffff;\n  --color-border-rgb: 255, 255, 255;\n  --color-border-light: #cccccc;\n  --color-border-light-rgb: 204, 204, 204;\n  \n  --color-primary: #ffffff;\n  --color-primary-rgb: 255, 255, 255;\n  --color-secondary: #ffff00;\n  --color-secondary-rgb: 255, 255, 0;\n  --color-accent: #ff0000;\n  --color-accent-rgb: 255, 0, 0;\n  \n  --color-success: #00ff00;\n  --color-success-rgb: 0, 255, 0;\n  --color-warning: #ffff00;\n  --color-warning-rgb: 255, 255, 0;\n  --color-error: #ff0000;\n  --color-error-rgb: 255, 0, 0;\n  --color-info: #00ffff;\n  --color-info-rgb: 0, 255, 255;\n}\n\n/* Reduced Motion Preferences */\n@media (prefers-reduced-motion: reduce) {\n  :root {\n    --transition-none: none;\n    --transition-all: none;\n    --transition-fast: none;\n    --transition-base: none;\n    --transition-slow: none;\n    --transition-slower: none;\n    \n    --duration-75: 0ms;\n    --duration-100: 0ms;\n    --duration-150: 0ms;\n    --duration-200: 0ms;\n    --duration-300: 0ms;\n    --duration-500: 0ms;\n    --duration-700: 0ms;\n    --duration-1000: 0ms;\n  }\n}\n\n/* High Contrast Preference */\n@media (prefers-contrast: high) {\n  :root:not([data-theme]) {\n    --color-border: #000000;\n    --color-text: #000000;\n    --color-background: #ffffff;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
